var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader")
      .delay(1000)
      .fadeOut(1000, function () {
        if ($(".preloader-overflow").length > 0) {
          $("body").removeClass("preloader-overflow");
        }
      });
  });
}
 
$(document).ready(function () {
    var Dwin = $(this); 
    if (Dwin.width() > 1024) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});
 
$(window).on('resize', function(){
    var win = $(this); 
    if (win.width() > 1024) {
      slickVeritcal();
    }
  else
    {
      slickHorizontal();
    }    
});

function slickVeritcal() {       
  if ($(".media-slick-slider  .thumbnail-list li").length > 6) {
  $(".thumbnail-list").not(".slick-initialized").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical:true,        
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [   
    {
      breakpoint: 1024,
      settings: {
        vertical: false,
      }
    },   
      {
      breakpoint: 1541,
      settings: {       
          slidesToShow: 3,
          slidesToScroll: 1
      }
    } 
    ]
  });

  }  
}
function slickHorizontal() {    
    if ($(".media-slick-slider  .thumbnail-list li").length > 5) {
      $(".thumbnail-list").slick("unslick");   
}
}

$(window).scroll(function () {
  if ($(window).width() > "1024") {
    if ($(window).scrollTop() >= 700) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < "1024") {
    if ($(window).scrollTop() >= 900) {      
      $(".sticky-bar").addClass("active");
    } else {       
      $(".sticky-bar").removeClass("active");
    }
  }
});

$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });  
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
if ($(".pagination-method-loadmore_btn").length > 0) {
  var AjaxMethod = "click";
} else {
  var AjaxMethod = "scroll";
}
if ($(".collection #AjaxinatePagination").length > 0) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  $('.facet-checkbox input:checkbox').each(function () {
  if($(this).is(':checked')){
       $(this).parent('.facet-checkbox').addClass('active');
    }     
  });
hotSpot();  
cardSwatch();
  
  if ($(".toggleFilter").length > 0) {
    const filter = document.querySelector(".toggleFilter");
    const sidebar = document.querySelector(".facets-vertical");
    const closeDiv = document.querySelector(".close-sidebar");

    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden");
      $("body").addClass("filter-clicked");
    });

    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden");
      $("body").removeClass("filter-clicked");
    });
  }



  $(".custom-product-grid li").click(function () {
    var classNames ="list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    var getCols = $(this).data("cols");
    var getVal = $(this).data("val");
    var getVal = "align-"+getVal+"-column";    
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols+" "+getVal);
  });
  if ($(".filter-buttons").length > 0) {
    const viewExists = document.querySelector(".grid-view-button");
    if (viewExists.classList.contains("layout-mode")) {
      const listViewButton = document.querySelector(".list-view-button");
      const gridViewButton = document.querySelector(".grid-view-button");
      const list = document.querySelector("ul.view-mode");
      const gridviewlist = document.querySelector(".custom-product-grid");

      listViewButton.onclick = function () {
        listViewButton.classList.add("active");
        gridViewButton.classList.remove("active");
        list.classList.remove("grid-view-filter");
        list.classList.add("list-view-filter");
        gridviewlist.classList.add("hidden");
      };

      gridViewButton.onclick = function () {
        listViewButton.classList.remove("active");
        gridViewButton.classList.add("active");
        list.classList.remove("list-view-filter");
        list.classList.add("grid-view-filter");
        gridviewlist.classList.remove("hidden");
      };
    }
  }
  if ($("#swiper-sidebar-carousel").length > 0) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    $(".loading-image").removeClass("loading-image").addClass("loaded-image");
  }, 2000);

  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  var selectedRadioButton;
  for (const radioButton of radioButtons) {
    if (radioButton.checked) {
      selectedRadioButton = radioButton.getAttribute("data-value");      
      optionSummary.innerHTML = selectedRadioButton;    
    }
  }
  
}

// function cardSwatch() {
//    // Item swatch trigger start
// $("body").on("click", ".color-values a", function(event) {
//   console.log(event.target); 
//   var $colorLinks = $(this).closest('.variant-option-color').find('.color-values a');
//   $colorLinks.removeClass("active");
//   $(this).addClass("active");
// });


// $("body").on("click", ".size-values a", function () {
//     $(".size-values a").removeClass("active");
//     $(this).addClass("active");
// });

// $("body").on("click", ".color-values-plus a", function (e) {
//     e.preventDefault();
//     $(this).parents(".variant-option-color").find(".show-on-click").css("display", "flex");
//     $(this).parents(".color-values-plus").css("display", "none");
// });

// $("body").on("click", ".swatch span", function (eventDT) {     
//     var $cardWrapper = $(this).parents(".card-wrapper");
//     var $motionReduce = $cardWrapper.find(".card__inner .motion-reduce");
//     var imageUrl = $(this).data("image");

//     $motionReduce.attr("srcset", imageUrl);

//     if ($(this).parents(".swatch").hasClass("color")) {
//         var variant = $(this).data("id");
//         $(this).parents(".product-grid").find(".variant-push").val(variant);

//         var swatchItem = $(this).data("variant-item");

//         $(this).parents(".product-grid").find(".variant-option-size .size-values").removeClass("active");

//         $(this).parents(".product-grid").find(".variant-option-size .swatch").each(function () {
//             var swatchSizeVars = $(this).find("span").data("variant-title").split("/").map($.trim).map(function (n) {
//                 return n.toLowerCase().replace(/ /g, "-");
//             });

//             if ($.inArray(swatchItem, swatchSizeVars) >= 0) {
//                 $(this).parent(".size-values").toggleClass("active");
//             }
//         });
//     }

//     if ($(this).parents(".swatch").hasClass("size")) {
//         var variant = $(this).data("id");
//         $(this).parents(".product-grid").find(".variant-push").val(variant);
//     }
// });
// // Item swatch trigger end
   
// }
function cardSwatch() {
   // Item swatch trigger start
   $("body").on("click", ".color-values a", function(event) {
     console.log(event.target);
     var $colorLinks = $(this).closest('.variant-option-color').find('.color-values a');
     $colorLinks.removeClass("active");
     $(this).addClass("active");
   });

   $("body").on("click", ".size-values a", function () {
       $(".size-values a").removeClass("active");
       $(this).addClass("active");
   });

   $("body").on("click", ".color-values-plus a", function () {
       $(this).parents(".variant-option-color").find(".show-on-click").css("display", "flex");
       $(this).parents(".color-values-plus").css("display", "none");
   });

   $("body").on("click", ".swatch span", function (eventDT) {     
       var $cardWrapper = $(this).parents(".card-wrapper");
       var $motionReduce = $cardWrapper.find(".card__inner .motion-reduce");
       var imageUrl = $(this).data("image");

       $motionReduce.attr("srcset", imageUrl);

       if ($(this).parents(".swatch").hasClass("color")) {
           var variant = $(this).data("id");
           $(this).parents(".product-grid").find(".variant-push").val(variant);

           var swatchItem = $(this).data("variant-item");

           $(this).parents(".product-grid").find(".variant-option-size .size-values").removeClass("active");

           $(this).parents(".product-grid").find(".variant-option-size .swatch").each(function () {
               var swatchSizeVars = $(this).find("span").data("variant-title").split("/").map($.trim).map(function (n) {
                   return n.toLowerCase().replace(/ /g, "-");
               });

               if ($.inArray(swatchItem, swatchSizeVars) >= 0) {
                   $(this).parent(".size-values").toggleClass("active");
               }
           });
       }

       if ($(this).parents(".swatch").hasClass("size")) {
           var variant = $(this).data("id");
           $(this).parents(".product-grid").find(".variant-push").val(variant);
       }
   });
   // Item swatch trigger end
}

//FBT ul li select box
$("ul.custom-select").on("click", "li:not(.init)", function () {
  var selectedVal = $(this).data("option-value");  
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option")
    .attr("selected", false);
  $(this)
    .parents(".fbt-product__meta")
    .find(".selectVariant option[value=" + selectedVal + "]")
    .attr("selected", "selected")
    .trigger("change");
});

$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});

$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html());
  $(this).parent().children(".init").removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) {
    $("#add-frequently-bought").prop("disabled", true);
  } else {
    $("#add-frequently-bought").prop("disabled", false);
  }
});
loadedBg();
function loadedBg() {
  window.onload = function () {
    setTimeout(function () {
      $(".loading-image").removeClass("loading-image").addClass("loaded-image");
    }, 3000);
  };
}

jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});


document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
function closeDrawerMenu() {
  document.querySelector("body").classList.remove("overflow-hidden-tablet");
}

$("#dT_TopStickySearchBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").addClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "1");
  $("body").addClass("search-overlay-open");
});

$(".dT_TopStickySearchCloseBtn").click(function (ev) {
  ev.preventDefault();
  $("#dT_top-sticky").removeClass("search-show");
  $("#dT_top-sticky .search-modal").css("opacity", "0");
  $("body").removeClass("search-overlay-open");
});

setTimeout(function () {
  $("#AccessibleNav .sub-menu-block").show();
}, 1000);



$(document).ready(function () {
  setTimeout(function () {
 document.getElementById("MainContent").classList.remove("placeholder-shadow-blocks");
    }, 2000);
});



$(function() {
  $('.acc__title').click(function(j) {    
    var dropDown = $(this).closest('.dt-sc-tabs-content');
    $(this).closest('dt-sc-tabs-content').not(dropDown).slideUp();    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('dt-sc-tabs-content.active').removeClass('active');
      $(this).addClass('active');
    }    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});


$(document).ready(function(){ 
    $('.tablinks').click(function(){  
      $(".dt-sc-tabs-content").removeClass('tab-active-content');
      $(".dt-sc-tabs-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active-content");
      $(".tablinks").removeClass('active-tab');     
      $(this).addClass('active-tab');
     });
});



// $(document).ready(function() {
//   $('.dt-sc-hotspot-marker').on('click', function() {   
//     $('.dt-sc-hotspot-popup').hide();
//     const targetPopup = $(this).data('target');
//     $('#' + targetPopup).show();
//   });
//   $(document).on('click', function(event) {
//     if (!$(event.target).closest('.dt-sc-hotspot-marker, .dt-sc-hotspot-popup').length) {
//       $('.dt-sc-hotspot-popup').hide();
//     }
//   });
// });



$(document).ready(function () {
    hotSpot();  
});
$(window).on("resize", function () {
    hotSpot();  
});

function hotSpot() {
    if ($(window).width() > 250) {
        if ($('.tool-tip-style-1').length > 0) {
            $('.dt-sc-hotspot-item').each(function () {
                var $pop = $(this).find('.dt-sc-hotspot-popup');
                $pop.click(function (e) {
                   e.stopPropagation();
                   e.stopImmediatePropagation();
                });

                $(this).find('a.dt-sc-hotspot-marker').click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    var $thisHotspot = $(this).parent().parent();
                    $thisHotspot.addClass('this-hotspot-in-active');

                    if ($(this).hasClass("clicked")) {
                        $(this).removeClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'none'});
                        $('.dt-sc-hotspot-item').removeClass('open');
                        $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'none'});                      
                    } else {
                        $(this).addClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $(this).parent().addClass('open');
                        $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
                        $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
                    }
                 
                });

                $(document).click(function () {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });
            });
        }

        if ($('.tool-tip-style-3').length > 0) {
            $('.dt-sc-hotspot-item').each(function () {
                var $pop = $(this).find('.dt-sc-hotspot-popup');
                $pop.hover(function (e) {
                   e.stopPropagation();
                });

                $(this).find('a.dt-sc-hotspot-marker').hover(function (e) {
                   e.preventDefault();
                   e.stopPropagation();

                    var $thisHotspot = $(this).parent().parent();
                    $thisHotspot.addClass('this-hotspot-in-active');

                    if ($(this).hasClass("clicked")) {
                        $(this).removeClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $('.dt-sc-hotspot-item').removeClass('open');
                        $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                    } else {
                        $(this).addClass("clicked");
                        $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({'opacity': '0', 'pointer-events': 'none'});
                        $(this).css({'opacity': '1', 'pointer-events': 'auto'});
                        $(this).parent().addClass('open');
                        $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
                        $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
                    }
                });

                $(this).find('a.dt-sc-hotspot-marker').mouseout(function (e) {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });

                $(document).click(function () {
                    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
                    $pop.removeClass('dt-sc-popup-open');
                    $('.dt-sc-hotspot-item').removeClass('open');
                    $('a.dt-sc-hotspot-marker').removeClass('clicked');
                    $('a.dt-sc-hotspot-marker').css({'opacity': '1', 'pointer-events': 'auto'});
                });
            });
        }
    }

    if ($(window).width() < 251) {
        $('.dt-sc-hotspot-popup').addClass('mfp-hide');
        $('.dt-sc-hotspot-marker').each(function () {
            $(this).magnificPopup({
                type: 'inline',
                closeOnBgClick: true,
                closeBtnInside: false,
                showCloseBtn: true
            });
        });
    }
}

function makeTimer() {

  $('.product-deal-count').each(function() {
    var dateAttr = $(this).attr('data-end-time');
    if (!dateAttr || isNaN(Date.parse(dateAttr))) {
      $(this).closest('.deals-counter').hide();
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
      return;
    }
    var endTime = new Date(dateAttr);		
    endTime = (Date.parse(endTime) / 1000);

    var now = new Date();
    now = (Date.parse(now) / 1000);

    var timeLeft = endTime - now;
    
    if(timeLeft > 0) {
      var days = Math.floor(timeLeft / 86400); 
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

      if (hours < 10) { hours = "0" + hours; }
      if (minutes < 10) { minutes = "0" + minutes; }
      if (seconds < 10) { seconds = "0" + seconds; }
      var daysText = (window.deals && window.deals.days) ? window.deals.days : "Days";
      var hoursText = (window.deals && window.deals.hours) ? window.deals.hours : "Hours";
      var minutesText = (window.deals && window.deals.minutes) ? window.deals.minutes : "Mins";
      var secondsText = (window.deals && window.deals.seconds) ? window.deals.seconds : "Sec";
      $(this).find(".days").html(days + "<span>" + daysText + "</span>");
      $(this).find(".hours").html(hours + "<span>" + hoursText + "</span>");
      $(this).find(".minutes").html(minutes + "<span>" + minutesText + "</span>");
      $(this).find(".seconds").html(seconds + "<span>" + secondsText + "</span>");
      $(this).find(".deal-clock").css('visibility', 'visible').show();
      $(this).closest('.deals-counter').show();
    } else {
      $(this).closest('.deals-counter').hide();
      $(this).find(".deal-lable").hide();
      $(this).find(".deal-clock").hide();
    }
  });
}

setInterval(function() { makeTimer(); }, 1000);

/* ==========================================================================
   Format Policy Pages into Premium Card & Icon List Layout (SandAgro Design)
   ========================================================================== */
function formatPolicyPages() {
  var $policyContainer = $('.shopify-policy__container');
  if (!$policyContainer.length) return;

  var $body = $policyContainer.find('.shopify-policy__body .rte, .shopify-policy__body');
  if (!$body.length || $body.find('.policy-card').length) return;

  // 1. Format Title & Subtitle
  var $titleEl = $policyContainer.find('.shopify-policy__title h1');
  var rawTitle = $titleEl.text().trim();
  var lowerTitle = rawTitle.toLowerCase();
  
  var formattedTitle = rawTitle.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
  $titleEl.text(formattedTitle);

  var subtitleText = "At Sand Agro, customer satisfaction is our priority. Please read our policy carefully.";
  if (lowerTitle.indexOf('refund') !== -1 || lowerTitle.indexOf('return') !== -1) {
    subtitleText = "At Sand Agro, customer satisfaction is our priority. Please read our refund policy carefully.";
  } else if (lowerTitle.indexOf('shipping') !== -1 || lowerTitle.indexOf('delivery') !== -1) {
    subtitleText = "At Sand Agro, we ensure safe and reliable delivery. Please read our shipping terms carefully.";
  } else if (lowerTitle.indexOf('privacy') !== -1) {
    subtitleText = "At Sand Agro, we are committed to safeguarding your personal data and privacy.";
  } else if (lowerTitle.indexOf('terms') !== -1 || lowerTitle.indexOf('service') !== -1) {
    subtitleText = "Please review the terms and conditions that govern your use of the Sand Agro website.";
  }

  if (!$policyContainer.find('.shopify-policy__subtitle').length) {
    $('<p class="shopify-policy__subtitle">' + subtitleText + '</p>').insertAfter($policyContainer.find('.shopify-policy__title'));
  }

  // 2. SVG Icons Mapping
  var icons = {
    exchange: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/></svg>',
    calendar: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/><path d="M8 14h.01"/><path d="M12 14h.01"/><path d="M16 14h.01"/><path d="M8 18h.01"/><path d="M12 18h.01"/></svg>',
    package: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m16.5 9.4-9-5.19M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14v10Z"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    globe: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>',
    credit_card: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>',
    document: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>',
    legal: '<svg viewBox="0 0 24 24" fill="none" stroke="#2d5016" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h18"/></svg>'
  };

  // 3. Extract items from paragraphs/lines
  var rawParagraphs = [];
  $body.find('p, li').each(function() {
    var txt = $(this).html().trim();
    if (txt) rawParagraphs.push(txt);
  });

  if (!rawParagraphs.length) {
    var directText = $body.html().split(/<br\s*[\/]?>/gi);
    directText.forEach(function(t) {
      var clean = t.trim();
      if (clean) rawParagraphs.push(clean);
    });
  }

  if (!rawParagraphs.length) return;

  var itemsHtml = '';
  rawParagraphs.forEach(function(htmlText) {
    var plain = $('<div>').html(htmlText).text().trim();
    var lower = plain.toLowerCase();
    if (!plain) return;

    var heading = 'Information';
    var iconSvg = icons.document;

    // Refund Policy matches
    if (lower.indexOf('exchange only') !== -1 || lower.indexOf('damaged products') !== -1) {
      heading = 'Exchange Only';
      iconSvg = icons.exchange;
    } else if (lower.indexOf('request a return') !== -1 || lower.indexOf('3 days') !== -1) {
      heading = 'Return Request';
      iconSvg = icons.calendar;
    } else if (lower.indexOf('unused') !== -1 || lower.indexOf('packaging') !== -1) {
      heading = 'Product Condition';
      iconSvg = icons.package;
    } else if (lower.indexOf('shipping cost') !== -1 || lower.indexOf('borne by') !== -1) {
      heading = 'Shipping Cost';
      iconSvg = icons.truck;
    } else if (lower.indexOf('no refunds') !== -1 || lower.indexOf('exchanges are allowed') !== -1) {
      heading = 'Refund Policy';
      iconSvg = icons.shield;
    }
    // Shipping Policy matches
    else if (lower.indexOf('ships products only within') !== -1 || lower.indexOf('within india') !== -1) {
      heading = 'Domestic Shipping';
      iconSvg = icons.globe;
    } else if (lower.indexOf('business days') !== -1 || lower.indexOf('processed and delivered') !== -1) {
      heading = 'Delivery Timeline';
      iconSvg = icons.calendar;
    } else if (lower.indexOf('shipping charges') !== -1 || lower.indexOf('calculated at checkout') !== -1) {
      heading = 'Shipping Charges';
      iconSvg = icons.truck;
    } else if (lower.indexOf('cash on delivery') !== -1 || lower.indexOf('cod') !== -1) {
      heading = 'Payment Policy';
      iconSvg = icons.credit_card;
    } else if (lower.indexOf('delivery delays') !== -1 || lower.indexOf('unforeseen circumstances') !== -1) {
      heading = 'Delivery Terms';
      iconSvg = icons.alert;
    }
    // Terms of Service matches
    else if (lower.indexOf('govern the use') !== -1 || lower.indexOf('terms & conditions') !== -1) {
      heading = 'Website Terms';
      iconSvg = icons.document;
    } else if (lower.indexOf('accessing this website') !== -1 || lower.indexOf('bound by these terms') !== -1) {
      heading = 'User Agreement';
      iconSvg = icons.document;
    } else if (lower.indexOf('intellectual property') !== -1 || lower.indexOf('content, images') !== -1) {
      heading = 'Intellectual Property';
      iconSvg = icons.shield;
    } else if (lower.indexOf('acceptance and availability') !== -1 || lower.indexOf('orders placed') !== -1) {
      heading = 'Order Acceptance';
      iconSvg = icons.package;
    } else if (lower.indexOf('cancel orders') !== -1 || lower.indexOf('pricing issues') !== -1) {
      heading = 'Order Cancellation';
      iconSvg = icons.alert;
    } else if (lower.indexOf('indian laws') !== -1 || lower.indexOf('govern these terms') !== -1) {
      heading = 'Governing Law';
      iconSvg = icons.legal;
    }
    // Privacy Policy matches
    else if (lower.indexOf('describes how sand agro collects') !== -1 || lower.indexOf('this privacy policy') !== -1) {
      heading = 'Policy Scope';
      iconSvg = icons.document;
    } else if (lower.indexOf('name, address, phone') !== -1 || lower.indexOf('collect personal information') !== -1) {
      heading = 'Information Collection';
      iconSvg = icons.user;
    } else if (lower.indexOf('third-party payment') !== -1 || lower.indexOf('card details directly') !== -1) {
      heading = 'Payment Security';
      iconSvg = icons.lock;
    } else if (lower.indexOf('process orders') !== -1 || lower.indexOf('promotional emails') !== -1) {
      heading = 'Data Usage';
      iconSvg = icons.mail;
    } else if (lower.indexOf('security practices') !== -1 || lower.indexOf('protect your personal data') !== -1) {
      heading = 'Security Practices';
      iconSvg = icons.shield;
    } else if (lower.indexOf('consent to this privacy') !== -1) {
      heading = 'User Consent';
      iconSvg = icons.shield;
    } else if (lower.indexOf('questions, contact') !== -1 || lower.indexOf('@sandagro.com') !== -1) {
      heading = 'Customer Support';
      iconSvg = icons.mail;
    }

    itemsHtml += '<div class="policy-card-item">' +
      '<div class="policy-card-icon">' + iconSvg + '</div>' +
      '<div class="policy-card-content">' +
        '<h3 class="policy-card-heading">' + heading + '</h3>' +
        '<p class="policy-card-desc">' + htmlText + '</p>' +
      '</div>' +
    '</div>';
  });

  $body.html('<div class="policy-card">' + itemsHtml + '</div>');
}

$(document).ready(function() {
  formatPolicyPages();
});
document.addEventListener('DOMContentLoaded', function() {
  formatPolicyPages();
});
